;(function () {
  'use strict'

  angular
    .module('deskfy.arts')
    .directive('twitterPreview', twitterPreview)

  function twitterPreview () {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        thumbnail: '<',
        data: '<'
      },
      templateUrl: '/arts/directives/twitter-preview/twitter-preview-directive.html?$$REVISION$$'
    }
  }
})()
